import request from '@/utils/request'

/**
 * 订单综合统计
 * @param data
 */
export function orderComplexReport(data) {
  return request({
    url: 'api/orderComplexReport',
    method: 'post',
    params: data
  })
}

/**
 * 订单关联的经销商
 * @param data
 */
export function getOrderReportDealer(data) {
  return request({
    url: 'api/getOrderReportDealer',
    method: 'post',
    params: data
  })
}

/**
 * 售后原因分析
 * @param data
 */
export function getAfterReasonReport(data) {
  return request({
    url: 'api/getAfterReasonReport',
    method: 'post',
    params: data
  })
}

/**
 * 售后部门分析
 * @param data
 */
export function getAfterDeptReport(data) {
  return request({
    url: 'api/getAfterDeptReport',
    method: 'post',
    params: data
  })
}

/**
 * 售后具体原因分析
 * @param data
 */
export function getAfterReasonDetailReport(data) {
  return request({
    url: 'api/getAfterReasonDetailReport',
    method: 'post',
    params: data
  })
}

/**
 * 业绩趋势分析
 * @param data
 */
export function getPerformanceReport(data) {
  return request({
    url: 'api/getPerformanceReport',
    method: 'post',
    params: data
  })
}

/**
 * 业绩趋势往年对比
 * @param data
 */
export function getLastYearPerformanceReport(data) {
  return request({
    url: 'api/getLastYearPerformanceReport',
    method: 'post',
    params: data
  })
}
/**
 * 周产能报表
 * @param data
 */
export function getProduceEnergyExcel(data) {
  return request({
    url: 'api/getProduceEnergyExcel',
    method: 'post',
    params: data
  })
}

/**
 * 周产能报表导出
 * @param data
 */
export function exportProduceEnergyExcel(data) {
  return request({
    url: 'api/exportProduceEnergyExcel',
    method: 'post',
    params: data
  })
}

/**
 * 正单生产数据
 * @param data
 */
export function getOrderDeliveryDetail(data) {
  return request({
    url: 'api/getOrderDeliveryDetail',
    method: 'post',
    params: data
  })
}

/**
 * 补单生产数据
 * @param data
 */
export function getAddOrderDeliveryDetail(data) {
  return request({
    url: 'api/getAddOrderDeliveryDetail',
    method: 'post',
    params: data
  })
}

/**
 * 售后数据
 * @param data
 */
export function getMonthFactoryData(data) {
  return request({
    url: 'api/getMonthFactoryData',
    method: 'post',
    params: data
  })
}

/**
 * 地图数据
 * @param data
 */
export function getHeighMapData() {
  return request({
    url: 'api/getHeighMapData',
    method: 'post'
  })
}

/**
 * 获取售后回访统计数据
 * @param data
 */
export function getAfterVisitReport(data) {
  return request({
    url: 'api/getAfterVisitReport',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后数据明细统计数据
 * @param data
 */
export function getAfterDetailStatisticsData(data) {
  return request({
    url: 'api/getAfterDetailStatisticsData',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后分析表统计数据
 * @param data
 */
export function getAfterAnalysisTableData(data) {
  return request({
    url: 'api/getAfterAnalysisTableData',
    method: 'post',
    params: data
  })
}
/**
 * 获取业绩分析的经销商业绩分析对比数据
 * @param data
 */
export function getDelerPerformanceComparison(data) {
  return request({
    url: 'api/getDelerPerformanceComparison',
    method: 'post',
    params: data
  })
}
